const env = import.meta.env;

function splitList(value: string | undefined): string[] {
  return (value ?? '')
    .split(',')
    .map((entry) => entry.trim())
    .filter(Boolean);
}

function positiveIntEnv(value: string | undefined, fallback: number): number {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : fallback;
}

export const config = {
  identityApiBase: env.VITE_IDENTITY_API_BASE ?? '/v1',
  defaultCoreUrl: env.VITE_DEFAULT_CORE_URL ?? '',
  defaultPortalUrl: env.VITE_DEFAULT_PORTAL_URL ?? 'https://sense-ai.co',
  allowedRedirectSchemes: splitList(env.VITE_ALLOWED_REDIRECT_SCHEMES ?? 'senseai://'),
  allowedRedirectOrigins: [
    ...splitList(
      env.VITE_ALLOWED_REDIRECT_ORIGINS ?? 'https://sense-ai.co,https://core.sense-ai.co,https://localhost',
    ),
    ...splitList(env.VITE_ALLOWED_LOCAL_DEV_REDIRECT_ORIGINS),
  ],
  cognito: {
    region: env.VITE_COGNITO_REGION ?? 'us-east-2',
    userPoolId: env.VITE_COGNITO_USER_POOL_ID ?? '',
  },
  storageKey: 'senseai_auth',
  redirectStorageKey: 'senseai_login_redirect',
  resendCooldownSeconds: positiveIntEnv(env.VITE_RESEND_COOLDOWN_SECONDS, 30),
  passwordMinLength: positiveIntEnv(env.VITE_PASSWORD_MIN_LENGTH, 8),
} as const;
